import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=10c3de75&scoped=true&"
import script from "./ApproveModal.vue?vue&type=script&lang=js&"
export * from "./ApproveModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveModal.vue?vue&type=style&index=0&id=10c3de75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3de75",
  null
  
)

export default component.exports